module.exports = __webpack_public_path__ + "img/swiatlowody.5db80f92.svg";